import React from "react";

const Work = () => (
  <div className="row work">
    <div className="three columns header-col">
      <h1>
        <span>Work</span>
      </h1>
    </div>

    <div className="nine columns main-col">
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Share Meals</h4>
	          <p className="info mb0">
	            Founder, CEO
	            &bull;
	            2013 to Present
	          </p>
	          <p>
		      Organization ending hunger on college campuses
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Brooklyn EOC</h4>
	          <p className="info mb0">
	            Adjunct Lecturer
	            &bull;
	            2017 to Present
	          </p>
	          <p>
		      TABE and developmental literacy skills with continuing education students
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Cooper Union STEM Program</h4>
	          <p className="info mb0">
	            Adjunct Instructor
	            &bull;
	            2016 to Present
	          </p>
	          <p>
		      Intensive weekend and summer computer science courses with high school students
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">New York University</h4>
	          <p className="info mb0">
	            Front End Developer
	            &bull;
	            2018 to Present
	          </p>
	          <p>
		      Develop user facing features for various NYU departments
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">staRt</h4>
	          <p className="info mb0">
	            React Native App Developer
	            &bull;
	            2018 to Present
	          </p>
	          <p>
		      Port and extend existing NIH funded Ionic app for speech therapy to React Native
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Pace University</h4>
	          <p className="info mb0">
	            Instructor
	            &bull;
	            2010 to Present
	          </p>
	          <p>
		      Credited survey class in Taekwondo
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">CityTech</h4>
	          <p className="info mb0">
	            Adjunct Lecturer
	            &bull;
	            2017
	          </p>
	          <p>
		      First year English composition
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Manhattan EOC</h4>
	          <p className="info mb0">
	            Adjunct Professor
	            &bull;
	            2013 to 2016
	          </p>
	          <p>
		      TABE and developmental literacy, science, and math with adult learners
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Rikers Island</h4>
	          <p className="info mb0">
	            Adjunct Professor
	            &bull;
	            2014
	          </p>
	          <p>
		      Pre-college prep for incarcerated female students
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">College Now</h4>
	          <p className="info mb0">
	            Adjunct Professor
	            &bull;
	            2014 to 2016
	          </p>
	          <p>
		      College level first year seminar and speech &amp; theater courses for hs students at Queensborough CC, EBC HS for Public Service, and Canarsie HS 
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">Brooklyn College</h4>
	          <p className="info mb0">
	            Adjunct Professor
	            &bull;
	            2010 to 2014
	          </p>
	          <p>
		      First year college learning community
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">College of New Rochelle</h4>
	          <p className="info mb0">
	            Adjunct Professor
	            &bull;
	            2010 to 2013
	          </p>
	          <p>
		      Introductory composition, journal writing, and GED/BA program for adult learners
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
	      <div className="row item">
	        <div className="twelve columns">
	          <h4 className="mb0">New York University</h4>
	          <p className="info mb0">
	            Assistant Coach
	            &bull;
	            2015 to 2016
	          </p>
	          <p>
		      Nationally medal winning competition team in Taekwondo
	          </p>
	          <ul>
		  </ul>
	        </div>
	      </div>
    </div>
  </div>
);

export default Work;



// WEBPACK FOOTER //
// ./src/components/resume/Work.jsx